<template>
    <div class="mb-4">
        <div v-if="allJobs.length === 0" class="text-center py-8 text-gray-400">
            <ElIconDownload :width="48" class="mx-auto mb-2 opacity-20"></ElIconDownload>
            <p>No active downloads</p>
        </div>
        <div v-else>
            <div class="flex justify-end mb-4">
                <el-button @click="cancelAll()" type="text" size="small">Cancel All</el-button>
            </div>

            <div v-if="activeJobs.length > 0" class="mb-6 p-4 bg-blue-50 rounded-lg border border-blue-100">
                <div class="flex justify-between items-center mb-2">
                    <span class="text-sm font-medium text-blue-700">Overall Progress ({{ activeJobs.length }} active)</span>
                    <span class="text-sm font-bold text-blue-700">{{ Math.round(overallProgress) }}%</span>
                </div>
                <el-progress :percentage="Math.round(overallProgress)" :stroke-width="12" :show-text="false" status="success"></el-progress>
                <div class="mt-2 text-xs text-blue-600 flex justify-between">
                    <span>{{ Math.round(overallBytesDone / 1e6) }} MB downloaded</span>
                    <span v-if="overallBytesTotal > 0">Total ~{{ Math.round(overallBytesTotal / 1e6) }} MB</span>
                </div>
            </div>

            <div v-for="item in allJobs.filter(job => job.status != 'waiting')" :key="item.id">
                <DownloadProgress :job="item"/>
            </div>
            <div class="my-2 flex items-center gap-2" v-if="waitingJobs.length > 0">
                <ElIconInfoFilled :width="16"></ElIconInfoFilled>
                {{waitingJobs.length}} more downloads are waiting in queue
            </div>
        </div>
    </div>
</template>

<script>
import { Download as ElIconDownload, InfoFilled as ElIconInfoFilled } from '@element-plus/icons-vue'

export default {
    components: {
        ElIconDownload,
        ElIconInfoFilled
    },
    inject: ['jobs', 'hlsJobs', 'drmJobs', 'dashJobs', 'downloadJobs', 'chunkedJobs', 'nativeJobs'],
    computed: {
        allJobs () {
            return this.jobs ? this.jobs() : []
        },
        activeJobs () {
            return this.allJobs.filter(job => job.status == 'running')
        },
        waitingJobs () {
            return this.allJobs.filter(job => job.status == 'waiting')
        },
        overallProgress () {
            if (this.activeJobs.length == 0) return 0
            const totalProgress = this.activeJobs.reduce((acc, job) => acc + (job.state?.progress?.progress || 0), 0)
            return (totalProgress / this.activeJobs.length) * 100
        },
        overallBytesDone () {
            return this.activeJobs.reduce((acc, job) => {
                const p = job.state?.progress
                return acc + (p?.bytesDone || p?.done || 0)
            }, 0)
        },
        overallBytesTotal () {
            return this.activeJobs.reduce((acc, job) => {
                const p = job.state?.progress
                return acc + (p?.bytesTotal || p?.total || 0)
            }, 0)
        },
    
    },
    methods: {
        async cancelAll () {
            const {cancelJob, useExtension} = useHelpers()
            this.allJobs.forEach(job => {
                cancelJob(job)
            })
            await useExtension('taskManager.cancelAll', [], 'sandbox')
        }
    }
}
</script>
